export default [
  {
    name: 'Afghanistan',
    value: 'Afghanistan'
  },
  {
    name: 'Afrique_Centrale',
    value: 'Afrique_Centrale '
  },
  {
    name: 'Afrique_du_sud',
    value: 'Afrique_du_Sud '
  },
  {
    name: 'Albanie',
    value: 'Albanie '
  },
  {
    name: 'Algerie',
    value: 'Algerie '
  },
  {
    name: 'Allemagne',
    value: 'Allemagne '
  },
  {
    name: 'Andorre',
    value: 'Andorre '
  },
  {
    name: 'Angola',
    value: 'Angola '
  },
  {
    name: 'Anguilla',
    value: 'Anguilla '
  },
  {
    name: 'Arabie_Saoudite',
    value: 'Arabie_Saoudite '
  },
  {
    name: 'Argentine',
    value: 'Argentine '
  },
  {
    name: 'Armenie',
    value: 'Armenie '
  },
  {
    name: 'Australie',
    value: 'Australie '
  },
  {
    name: 'Autriche',
    value: 'Autriche '
  },
  {
    name: 'Azerbaidjan',
    value: 'Azerbaidjan '
  },
  {
    name: 'Bahamas',
    value: 'Bahamas '
  },
  {
    name: 'Bangladesh',
    value: 'Bangladesh '
  },
  {
    name: 'Barbade',
    value: 'Barbade '
  },
  {
    name: 'Bahrein',
    value: 'Bahrein '
  },
  {
    name: 'Belgique',
    value: 'Belgique '
  },
  {
    name: 'Belize',
    value: 'Belize '
  },
  {
    name: 'Benin',
    value: 'Benin '
  },
  {
    name: 'Bermudes',
    value: 'Bermudes '
  },
  {
    name: 'Bielorussie',
    value: 'Bielorussie '
  },
  {
    name: 'Bolivie',
    value: 'Bolivie '
  },
  {
    name: 'Botswana',
    value: 'Botswana '
  },
  {
    name: 'Bhoutan',
    value: 'Bhoutan '
  },
  {
    name: 'Boznie_Herzegovine',
    value: 'Boznie_Herzegovine '
  },
  {
    name: 'Bresil',
    value: 'Bresil '
  },
  {
    name: 'Brunei',
    value: 'Brunei '
  },
  {
    name: 'Bulgarie',
    value: 'Bulgarie '
  },
  {
    name: 'Burkina_Faso',
    value: 'Burkina_Faso '
  },
  {
    name: 'Burundi',
    value: 'Burundi '
  },
  {
    name: 'Caiman',
    value: 'Caiman '
  },
  {
    name: 'Cambodge',
    value: 'Cambodge '
  },
  {
    name: 'Cameroun',
    value: 'Cameroun '
  },
  {
    name: 'Canada',
    value: 'Canada '
  },
  {
    name: 'Canaries',
    value: 'Canaries '
  },
  {
    name: 'Cap_vert',
    value: 'Cap_Vert '
  },
  {
    name: 'Chili',
    value: 'Chili '
  },
  {
    name: 'Chine',
    value: 'Chine '
  },
  {
    name: 'Chypre',
    value: 'Chypre '
  },
  {
    name: 'Colombie',
    value: 'Colombie '
  },
  {
    name: 'Comores',
    value: 'Colombie '
  },
  {
    name: 'Congo',
    value: 'Congo '
  },
  {
    name: 'Congo_democratique',
    value: 'Congo_democratique '
  },
  {
    name: 'Cook',
    value: 'Cook '
  },
  {
    name: 'Coree_du_Nord',
    value: 'Coree_du_Nord '
  },
  {
    name: 'Coree_du_Sud',
    value: 'Coree_du_Sud '
  },
  {
    name: 'Costa_Rica',
    value: 'Costa_Rica '
  },
  {
    name: 'Cote_d_Ivoire',
    value: 'Côte_d_Ivoire '
  },
  {
    name: 'Croatie',
    value: 'Croatie '
  },
  {
    name: 'Cuba',
    value: 'Cuba '
  },
  {
    name: 'Danemark',
    value: 'Danemark '
  },
  {
    name: 'Djibouti',
    value: 'Djibouti '
  },
  {
    name: 'Dominique',
    value: 'Dominique '
  },
  {
    name: 'Egypte',
    value: 'Egypte '
  },
  {
    name: 'Emirats_Arabes_Unis',
    value: 'Emirats_Arabes_Unis '
  },
  {
    name: 'Equateur',
    value: 'Equateur '
  },
  {
    name: 'Erythree',
    value: 'Erythree '
  },
  {
    name: 'Espagne',
    value: 'Espagne '
  },
  {
    name: 'Estonie',
    value: 'Estonie '
  },
  {
    name: 'Etats_Unis',
    value: 'Etats_Unis '
  },
  {
    name: 'Ethiopie',
    value: 'Ethiopie '
  },
  {
    name: 'Falkland',
    value: 'Falkland '
  },
  {
    name: 'Feroe',
    value: 'Feroe '
  },
  {
    name: 'Fidji',
    value: 'Fidji '
  },
  {
    name: 'Finlande',
    value: 'Finlande '
  },
  {
    name: 'France',
    value: 'France '
  },
  {
    name: 'Gabon',
    value: 'Gabon '
  },
  {
    name: 'Gambie',
    value: 'Gambie '
  },
  {
    name: 'Georgie',
    value: 'Georgie '
  },
  {
    name: 'Ghana',
    value: 'Ghana '
  },
  {
    name: 'Gibraltar',
    value: 'Gibraltar '
  },
  {
    name: 'Grece',
    value: 'Grece '
  },
  {
    name: 'Grenade',
    value: 'Grenade '
  },
  {
    name: 'Groenland',
    value: 'Groenland '
  },
  {
    name: 'Guadeloupe',
    value: 'Guadeloupe '
  },
  {
    name: 'Guam',
    value: 'Guam '
  },
  {
    name: 'Guatemala',
    value: 'Guatemala'
  },
  {
    name: 'Guernesey',
    value: 'Guernesey '
  },
  {
    name: 'Guinee',
    value: 'Guinee '
  },
  {
    name: 'Guinee_Bissau',
    value: 'Guinee_Bissau '
  },
  {
    name: 'Guinee equatoriale',
    value: 'Guinee_Equatoriale '
  },
  {
    name: 'Guyana',
    value: 'Guyana '
  },
  {
    name: 'Guyane_Francaise ',
    value: 'Guyane_Francaise '
  },
  {
    name: 'Haiti',
    value: 'Haiti '
  },
  {
    name: 'Hawaii',
    value: 'Hawaii '
  },
  {
    name: 'Honduras',
    value: 'Honduras '
  },
  {
    name: 'Hong_Kong',
    value: 'Hong_Kong '
  },
  {
    name: 'Hongrie',
    value: 'Hongrie '
  },
  {
    name: 'Inde',
    value: 'Inde '
  },
  {
    name: 'Indonesie',
    value: 'Indonesie '
  },
  {
    name: 'Iran',
    value: 'Iran '
  },
  {
    name: 'Iraq',
    value: 'Iraq '
  },
  {
    name: 'Irlande',
    value: 'Irlande '
  },
  {
    name: 'Islande',
    value: 'Islande '
  },
  {
    name: 'Israel',
    value: 'Israel '
  },
  {
    name: 'Italie',
    value: 'italie '
  },
  {
    name: 'Jamaique',
    value: 'Jamaique '
  },
  {
    name: 'Jan Mayen',
    value: 'Jan Mayen '
  },
  {
    name: 'Japon',
    value: 'Japon '
  },
  {
    name: 'Jersey',
    value: 'Jersey '
  },
  {
    name: 'Jordanie',
    value: 'Jordanie '
  },
  {
    name: 'Kazakhstan',
    value: 'Kazakhstan '
  },
  {
    name: 'Kenya',
    value: 'Kenya '
  },
  {
    name: 'Kirghizstan',
    value: 'Kirghizistan '
  },
  {
    name: 'Kiribati',
    value: 'Kiribati '
  },
  {
    name: 'Koweit',
    value: 'Koweit '
  },
  {
    name: 'Laos',
    value: 'Laos '
  },
  {
    name: 'Lesotho',
    value: 'Lesotho '
  },
  {
    name: 'Lettonie',
    value: 'Lettonie '
  },
  {
    name: 'Liban',
    value: 'Liban '
  },
  {
    name: 'Liberia',
    value: 'Liberia '
  },
  {
    name: 'Liechtenstein',
    value: 'Liechtenstein '
  },
  {
    name: 'Lituanie',
    value: 'Lituanie '
  },
  {
    name: 'Luxembourg',
    value: 'Luxembourg '
  },
  {
    name: 'Lybie',
    value: 'Lybie '
  },
  {
    name: 'Macao',
    value: 'Macao '
  },
  {
    name: 'Macedoine',
    value: 'Macedoine '
  },
  {
    name: 'Madagascar',
    value: 'Madagascar '
  },
  {
    name: 'Madère',
    value: 'Madère '
  },
  {
    name: 'Malaisie',
    value: 'Malaisie '
  },
  {
    name: 'Malawi',
    value: 'Malawi '
  },
  {
    name: 'Maldives',
    value: 'Maldives '
  },
  {
    name: 'Mali',
    value: 'Mali '
  },
  {
    name: 'Malte',
    value: 'Malte '
  },
  {
    name: 'Man',
    value: 'Man '
  },
  {
    name: 'Mariannes du Nord',
    value: 'Mariannes du Nord '
  },
  {
    name: 'Maroc',
    value: 'Maroc '
  },
  {
    name: 'Marshall',
    value: 'Marshall '
  },
  {
    name: 'Martinique',
    value: 'Martinique '
  },
  {
    name: 'Maurice',
    value: 'Maurice '
  },
  {
    name: 'Mauritanie',
    value: 'Mauritanie '
  },
  {
    name: 'Mayotte',
    value: 'Mayotte '
  },
  {
    name: 'Mexique',
    value: 'Mexique '
  },
  {
    name: 'Micronesie',
    value: 'Micronesie '
  },
  {
    name: 'Midway',
    value: 'Midway '
  },
  {
    name: 'Moldavie',
    value: 'Moldavie '
  },
  {
    name: 'Monaco',
    value: 'Monaco '
  },
  {
    name: 'Mongolie',
    value: 'Mongolie '
  },
  {
    name: 'Montserrat',
    value: 'Montserrat '
  },
  {
    name: 'Mozambique',
    value: 'Mozambique '
  },
  {
    name: 'Namibie',
    value: 'Namibie '
  },
  {
    name: 'Nauru',
    value: 'Nauru '
  },
  {
    name: 'Nepal',
    value: 'Nepal '
  },
  {
    name: 'Nicaragua',
    value: 'Nicaragua '
  },
  {
    name: 'Niger',
    value: 'Niger '
  },
  {
    name: 'Nigeria',
    value: 'Nigeria '
  },
  {
    name: 'Niue',
    value: 'Niue '
  },
  {
    name: 'Norfolk',
    value: 'Norfolk '
  },
  {
    name: 'Norvege',
    value: 'Norvege '
  },
  {
    name: 'Nouvelle_Caledonie',
    value: 'Nouvelle_Caledonie '
  },
  {
    name: 'Nouvelle_Zelande',
    value: 'Nouvelle_Zelande '
  },
  {
    name: 'Oman',
    value: 'Oman '
  },
  {
    name: 'Ouganda',
    value: 'Ouganda '
  },
  {
    name: 'Ouzbekistan',
    value: 'Ouzbekistan '
  },
  {
    name: 'Pakistan',
    value: 'Pakistan '
  },
  {
    name: 'Palau',
    value: 'Palau '
  },
  {
    name: 'Palestine',
    value: 'Palestine '
  },
  {
    name: 'Panama',
    value: 'Panama '
  },
  {
    name: 'Papouasie_Nouvelle_Guinee',
    value: 'Papouasie_Nouvelle_Guinee '
  },
  {
    name: 'Paraguay',
    value: 'Paraguay '
  },
  {
    name: 'Pays_Bas',
    value: 'Pays_Bas '
  },
  {
    name: 'Perou',
    value: 'Perou '
  },
  {
    name: 'Philippines',
    value: 'Philippines '
  },
  {
    name: 'Pologne',
    value: 'Pologne '
  },
  {
    name: 'Polynesie',
    value: 'Polynesie '
  },
  {
    name: 'Porto_Rico',
    value: 'Porto_Rico '
  },
  {
    name: 'Portugal',
    value: 'Portugal '
  },
  {
    name: 'Qatar',
    value: 'Qatar '
  },
  {
    name: 'Republique_Dominicaine',
    value: 'Republique_Dominicaine '
  },
  {
    name: 'Republique_Tcheque',
    value: 'Republique_Tcheque '
  },
  {
    name: 'Reunion',
    value: 'Reunion '
  },
  {
    name: 'Roumanie',
    value: 'Roumanie '
  },
  {
    name: 'Royaume_Uni',
    value: 'Royaume_Uni '
  },
  {
    name: 'Russie',
    value: 'Russie '
  },
  {
    name: 'Rwanda',
    value: 'Rwanda '
  },
  {
    name: 'Sahara Occidental',
    value: 'Sahara Occidental '
  },
  {
    name: 'Sainte_Lucie',
    value: 'Sainte_Lucie '
  },
  {
    name: 'Saint_Marin',
    value: 'Saint_Marin '
  },
  {
    name: 'Salomon',
    value: 'Salomon '
  },
  {
    name: 'Salvador',
    value: 'Salvador '
  },
  {
    name: 'Samoa_Occidentales',
    value: 'Samoa_Occidentales'
  },
  {
    name: 'Samoa_Americaine',
    value: 'Samoa_Americaine '
  },
  {
    name: 'Sao_Tome_et_Principe',
    value: 'Sao_Tome_et_Principe '
  },
  {
    name: 'Senegal',
    value: 'Senegal '
  },
  {
    name: 'Seychelles',
    value: 'Seychelles '
  },
  {
    name: 'Sierra Leone',
    value: 'Sierra Leone '
  },
  {
    name: 'Singapour',
    value: 'Singapour '
  },
  {
    name: 'Slovaquie',
    value: 'Slovaquie '
  },
  {
    name: 'Slovenie',
    value: 'Slovenie'
  },
  {
    name: 'Somalie',
    value: 'Somalie '
  },
  {
    name: 'Soudan',
    value: 'Soudan '
  },
  {
    name: 'Sri_Lanka',
    value: 'Sri_Lanka '
  },
  {
    name: 'Suede',
    value: 'Suede '
  },
  {
    name: 'Suisse',
    value: 'Suisse '
  },
  {
    name: 'Surinam',
    value: 'Surinam '
  },
  {
    name: 'Swaziland',
    value: 'Swaziland '
  },
  {
    name: 'Syrie',
    value: 'Syrie '
  },
  {
    name: 'Tadjikistan',
    value: 'Tadjikistan '
  },
  {
    name: 'Taiwan',
    value: 'Taiwan '
  },
  {
    name: 'Tonga',
    value: 'Tonga '
  },
  {
    name: 'Tanzanie',
    value: 'Tanzanie '
  },
  {
    name: 'Tchad',
    value: 'Tchad '
  },
  {
    name: 'Thailande',
    value: 'Thailande '
  },
  {
    name: 'Tibet',
    value: 'Tibet '
  },
  {
    name: 'Timor_Oriental',
    value: 'Timor_Oriental '
  },
  {
    name: 'Togo',
    value: 'Togo '
  },
  {
    name: 'Trinite_et_Tobago',
    value: 'Trinite_et_Tobago '
  },
  {
    name: 'Tristan da cunha',
    value: 'Tristan de cuncha '
  },
  {
    name: 'Tunisie',
    value: 'Tunisie '
  },
  {
    name: 'Turkmenistan',
    value: 'Turmenistan '
  },
  {
    name: 'Turquie',
    value: 'Turquie '
  },
  {
    name: 'Ukraine',
    value: 'Ukraine '
  },
  {
    name: 'Uruguay',
    value: 'Uruguay '
  },
  {
    name: 'Vanuatu',
    value: 'Vanuatu '
  },
  {
    name: 'Vatican',
    value: 'Vatican '
  },
  {
    name: 'Venezuela',
    value: 'Venezuela '
  },
  {
    name: 'Vierges_Americaines',
    value: 'Vierges_Americaines '
  },
  {
    name: 'Vierges_Britanniques',
    value: 'Vierges_Britanniques '
  },
  {
    name: 'Vietnam',
    value: 'Vietnam '
  },
  {
    name: 'Wake',
    value: 'Wake '
  },
  {
    name: 'Wallis et Futuma',
    value: 'Wallis et Futuma '
  },
  {
    name: 'Yemen',
    value: 'Yemen '
  },
  {
    name: 'Yougoslavie',
    value: 'Yougoslavie '
  },
  {
    name: 'Zambie',
    value: 'Zambie '
  },
  {
    name: 'Zimbabwe',
    value: 'Zimbabwe'
  }
]
